import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ff } from '../../../theme';
import { InfluencerCollabPhase, UGCCollabPhase } from 'utils/influencerCollabPhase';

interface Step {
  key: string;
  label: string;
}

const DRAFT_STEPS: Step[] = [
  { key: 'draft',      label: 'Draft' },
  { key: 'draftReview', label: 'Review' },
  { key: 'post',       label: 'Post' },
  { key: 'postReview', label: 'Review' },
  { key: 'complete',   label: 'Done' },
];

const NO_DRAFT_STEPS: Step[] = [
  { key: 'post',       label: 'Post' },
  { key: 'postReview', label: 'Review' },
  { key: 'complete',   label: 'Done' },
];

const UGC_WITH_CHANNELS_STEPS: Step[] = [
  { key: 'content',       label: 'Content' },
  { key: 'contentReview', label: 'Review' },
  { key: 'post',          label: 'Post' },
  { key: 'postReview',    label: 'Review' },
  { key: 'complete',      label: 'Done' },
];

const UGC_WITHOUT_CHANNELS_STEPS: Step[] = [
  { key: 'content',       label: 'Content' },
  { key: 'contentReview', label: 'Review' },
  { key: 'complete',      label: 'Done' },
];


interface Props {
  phase?: InfluencerCollabPhase;
  requireDraftApproval?: boolean;
  ugcPhase?: UGCCollabPhase;
  ugcHasChannels?: boolean;
}

const SubmissionPhaseIndicator: React.FC<Props> = ({
  phase,
  requireDraftApproval,
  ugcPhase,
  ugcHasChannels,
}) => {
  const isUGC = ugcPhase !== undefined;

  const steps = isUGC
    ? (ugcHasChannels ? UGC_WITH_CHANNELS_STEPS : UGC_WITHOUT_CHANNELS_STEPS)
    : (requireDraftApproval ? DRAFT_STEPS : NO_DRAFT_STEPS);

  const currentPhaseKey = isUGC ? ugcPhase : phase;
  const currentIndex = steps.findIndex(s => s.key === currentPhaseKey);

  // Board progress: done segments ink, the current one lime with an ink ring, later ones grey.
  return (
    <Box as="section" aria-label="Progress" fontFamily="display">
      <Flex gap="4px" aria-hidden>
        {steps.map((step, i) => (
          <Box
            key={step.key}
            flex={1}
            h="6px"
            borderRadius="full"
            bg={i < currentIndex ? ff.ink : i === currentIndex ? ff.lime : ff.card}
            boxShadow={i === currentIndex ? `inset 0 0 0 1.5px ${ff.ink}` : undefined}
          />
        ))}
      </Flex>
      <Flex gap="4px" mt="8px">
        {steps.map((step, i) => (
          <Text
            key={step.key}
            flex={1}
            fontSize="11px"
            fontWeight={600}
            letterSpacing="0.06em"
            textTransform="uppercase"
            lineHeight="normal"
            color={i <= currentIndex ? ff.ink : ff.text2}
            aria-current={i === currentIndex ? 'step' : undefined}
          >
            {step.label}
          </Text>
        ))}
      </Flex>
    </Box>
  );
};

export default SubmissionPhaseIndicator;
